/**
 * Filtrage sections ProduitModal — archétype (gelé) et création optimisée (Lot 1).
 */

import { PRODUCT_SECTION_LABELS } from '../config/produitSectionKeys.js';
import { ARCHETYPE_IDS, getArchetypeById } from '../config/produitArchetypes.js';
import { shouldShowCreationSection } from '../config/produitCreationVisibility.js';
import { getSectionVisibility } from './produitSectionVisibility.js';

/**
 * @param {string | null | undefined} archetypeId
 * @param {string} sectionKey
 * @param {{ enrichExpanded?: boolean, revealedSections?: Set<string>, creationMode?: boolean, showAllSections?: boolean }} [options]
 */
export function shouldShowProductSection(archetypeId, sectionKey, options = {}) {
  // Options utiles sur tous les types de fiche — toujours affichées (Lot options urgent)
  if (sectionKey === 'options') return true;

  const { creationMode = false, showAllSections = false, revealedSections = new Set() } = options;

  if (creationMode) {
    return shouldShowCreationSection(sectionKey, { showAllSections, revealedSections });
  }

  if (!archetypeId) return true;

  const { enrichExpanded = false } = options;
  const { visible, optional, hidden } = getSectionVisibility(archetypeId);

  if (visible.includes(sectionKey)) return true;
  if (optional.includes(sectionKey) && enrichExpanded) return true;
  if (hidden.includes(sectionKey) && revealedSections.has(sectionKey)) return true;
  return false;
}

export function hasOptionalSections(archetypeId) {
  if (!archetypeId || archetypeId === ARCHETYPE_IDS.AVANCE) return false;
  return getSectionVisibility(archetypeId).optional.length > 0;
}

export function getOptionalSectionLabels(archetypeId) {
  if (!archetypeId) return [];
  const { optional } = getSectionVisibility(archetypeId);
  return optional.map((k) => PRODUCT_SECTION_LABELS[k] ?? k);
}

export function getRevealableHiddenSections(archetypeId) {
  if (!archetypeId || archetypeId === ARCHETYPE_IDS.AVANCE) return [];
  const archetype = getArchetypeById(archetypeId);
  if (!archetype) return [];
  return (archetype.sections.hidden ?? []).map((key) => ({
    key,
    label: PRODUCT_SECTION_LABELS[key] ?? key,
  }));
}

/** TVA visible si la section prix est masquée mais le produit reste taxable. */
export function shouldShowStandaloneTva(archetypeId, options = {}) {
  if (!archetypeId) return false;
  if (shouldShowProductSection(archetypeId, 'prix', options)) return false;
  if (shouldShowProductSection(archetypeId, 'venteAuPoids', options)) return false;
  return true;
}

export function isArchetypeGuidedMode(archetypeId) {
  return Boolean(archetypeId && archetypeId !== ARCHETYPE_IDS.AVANCE);
}
